import {FETCH_PATH_REQUEST,FETCH_PATH_SUCCESS,FETCH_PATH_FAILURE} from './ConfigTypes'


const initialState = {
    loading: false,
    paths: {},
    error: ''
}


const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PATH_REQUEST: 
           return {
               ...state,
               loading: true
           }
        case FETCH_PATH_SUCCESS:
            return {
                loading: false,
                paths: action.payload,
                error: ''
            }
        case FETCH_PATH_FAILURE:
            return {
                loading: false,
                paths: [],
                error: action.payload
            } 
        default:
            return state
    }
}

export default reducer;